import React from 'react';
import './SimilarResults.css';

const SimilarResults = ({ results, scores, onPreview }) => {
  if (!results || results.length === 0) {
    return (
      <div className="no-results">
        <p>No se encontraron piezas similares</p>
      </div>
    );
  }

  // Obtener tipo de pieza del resultado
  const getTipoPieza = (analysis) => {
    return analysis.result?.TipoPieza || 'N/A';
  };

  // Contar operaciones activas
  const countActiveOps = (analysis) => {
    const ops = analysis.result?.OperacionesMecanizado || {};
    return Object.values(ops).filter(opData => {
      if (!opData) return false;
      return Object.values(opData).some(v =>
        v !== null && v !== undefined &&
        (Array.isArray(v) ? v.length > 0 : true)
      );
    }).length;
  };

  return (
    <div className="similar-results">
      <h3>Resultados ({results.length})</h3>

      <div className="results-grid">
        {results.map((analysis) => {
          const score = scores?.[analysis.hash] || 0;
          const scorePercent = Math.round(score * 100);
          const tipoPieza = getTipoPieza(analysis);
          const activeOps = countActiveOps(analysis);

          return (
            <div key={analysis.hash} className="result-card">
              <div className="result-header">
                <div className="similarity-score">
                  {scorePercent}%
                </div>
                <span className="tipo-badge">{tipoPieza}</span>
              </div>

              <div className="result-body">
                <h4>{analysis.filename}</h4>
                <div className="result-meta">
                  <span>{activeOps} operaciones</span>
                  <span>{new Date(analysis.created).toLocaleDateString('es-ES')}</span>
                </div>
              </div>

              <div className="result-actions">
                <button onClick={() => onPreview(analysis)} className="btn-view">
                  Ver detalles
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SimilarResults;
